<template>
	<div class="module-status-indication">
		<div class="module-status-indication flex-space-between--center flex-row">
			<ModuleActiveIndication :flowData="flowData" />
			<div class="flex-centerize" v-if="showIsOnSwitch">
				<div class="secondary-font-color font-size-sm mr-2">{{ flowActivityStatusText }}</div>
				<AppSwitch v-model="isFlowOn" :disabled="!canChangeState" />
			</div>
		</div>
	</div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import WorkflowService from '@/utils/WorkflowService';
import { editWorkflow } from '@/store/modules/selectedWorkflow/getters';
import { toggleWorkflowIsOnSettings } from '@/store/modules/workflows/actions';
import { FlowType } from '@ply-io/ply-front-shared-utilities';
import ModuleActiveIndication from '@/components/Modules/common/ModuleActiveIndication';

export default {
	name: 'ModuleConfigurationBar',
	components: {
		ModuleActiveIndication,
	},
	props: {
		flowData: { type: Object },
	},
	computed: {
		...mapGetters([editWorkflow.fullPath]),
		flowActivityStatusText() {
			if (!this.flowData.is_published) {
				return 'Draft can’t be made visible';
			}
			return this.isFlowOn ? 'On For me' : 'Off for me';
		},
		canChangeState() {
			return WorkflowService.canHideWorkflow(this.flowData);
		},
		showIsOnSwitch() {
			return this.flowData.flow_type === FlowType.Experience;
		},
	},
	methods: {
		...mapActions([toggleWorkflowIsOnSettings.fullPath]),
	},
	watch: {
		isFlowOn: {
			handler(oldVal, newVal) {
				if (newVal !== undefined && oldVal !== newVal) {
					this[toggleWorkflowIsOnSettings.fullPath]({ id: this.flowData.id });
				}
			},
			immediate: true,
		},
	},
	data() {
		return {
			isFlowOn: this.flowData.user_settings?.is_on,
		};
	},
};
</script>

<style scoped lang="scss"></style>
